export default function VendorIcon() {
  return (
    <svg
      width="23"
      height="23"
      viewBox="0 0 23 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.1449 2.32909C10.5191 2.11349 10.9433 2 11.3751 2C11.807 2 12.2313 2.1135 12.6054 2.32912L12.6071 2.33011L18.3563 5.61538C18.4904 5.69277 18.6163 5.78229 18.7326 5.88253L11.375 10.0868L4.01758 5.88257C4.13393 5.78232 4.25985 5.69278 4.39391 5.61539L4.39708 5.61355L10.1449 2.32909Z"
        fill="currentColor"
      />
      <path
        d="M3.2014 7.30811C3.17518 7.45222 3.16177 7.59894 3.16162 7.74655V14.3188C3.16206 14.7509 3.27612 15.1752 3.49236 15.5493C3.7086 15.9234 4.0194 16.2341 4.3936 16.4502L4.39677 16.452L10.1428 19.7354L10.1444 19.7363C10.2752 19.8117 10.4122 19.8747 10.5535 19.9246V11.5093L3.2014 7.30811Z"
        fill="currentColor"
      />
      <path
        d="M12.1963 19.9247C12.3376 19.8747 12.4746 19.8117 12.6055 19.7363L12.6069 19.7355L18.353 16.452L18.3562 16.4502C18.7304 16.2341 19.0412 15.9235 19.2574 15.5494C19.4737 15.1753 19.5878 14.7509 19.5882 14.3189V7.74661C19.588 7.59898 19.5746 7.45224 19.5484 7.30811L12.1963 11.5093V19.9247Z"
        fill="currentColor"
      />
    </svg>
  );
}
